import { useUser } from "../hooks/useUser";

const useMenus = () => {
  const { data: user } = useUser();

  if (!user || !user.role) {
    return [];
  }

  if (user.role === "admin") {
    return [
      {
        // 0 => Dashboard
        icon: "ri-home-line",
        menuName: "Dashboard",
        url: "/dashboard",
        submenu: [],
      },
      {
        // 1 => Product
        icon: "ri-store-3-line",
        menuName: "Inventory Management",
        url: "",
        submenu: [
          { menuName: "Vendor & Product", url: "/vendor/1" },
          { menuName: "List of product", url: "/listofproducts" },
          { menuName: "Add product", url: "/adminproductsaddorupdate" },
          { menuName: "Add stock", url: "/stockaddorupdate/" },
          { menuName: "Add Vendor", url: "/vendoraddorupdate/" },
          { menuName: "Vendor Applications", url: "/vendor-applications" }, // moved here
          { menuName: "Category & SubCategory", url: "/product-category-add" },
        ],
      },
      {
        // 2 => Employee
        icon: "ri-user-3-line",
        menuName: "Employee Management",
        url: "/vendor/2",
        submenu: [
          { menuName: "Employee", url: "/employee" },
          { menuName: "Add employee", url: "/employeeaddorupdate" },
          {
            menuName: "Employee Login History",
            url: "/employee-login-details",
          }, // <-- Added here
        ],
      },
      {
        // 3 => Drivers
        icon: "ri-user-3-line",
        menuName: "Drivers management",
        url: "/vendor/3",
        submenu: [
          { menuName: "Driver", url: "/driver" },
          { menuName: "Add driver", url: "/driveraddorupdate" },
        ],
      },
      {
        // 4 => Customer
        icon: "ri-user-3-line",
        menuName: "Customer Management",
        url: "/customer",
        submenu: [
          { menuName: "Customer", url: "/customer" },
          { menuName: "Contact Messages", url: "/ContactMessages" },
        ],
      },
      {
        // 5 => Order & delivery
        icon: "fas fa-truck",
        menuName: "Order & delivery",
        url: "/vendor/4",
        submenu: [
          { menuName: "Orders", url: "/order" },
          { menuName: "Assign Order", url: "/assign-order" },
          { menuName: "Driver Assignments", url: "/driver-assignments" },
          { menuName: "Review", url: "/review" },
          { menuName: "ReAssignDrivers", url: "/ReAssignDrivers" }
          // { menuName: "Delivery", url: "/delivery" },
        ],
      },
      {
        // 6 => Accounts
        icon: "fas fa-landmark",
        menuName: "Accounts",
        url: "#",
        submenu: [
          // { menuName: "Collection Cash", url: "/collectioncash" },
          { menuName: "Driver Deposit Cash", url: "/driverdepositcash" },
          { menuName: "Vendor Deposit Cash", url: "/vendordepositcash" },
          // ✅ NEW: Driver Commission
    { menuName: "Driver Commission", url: "/admin/driver-commission" },
        ],
      },
      {
        // 7 => Offer management
        icon: "fas fa-tags",
        menuName: "Offers management",
        url: "#",
        submenu: [
          { menuName: "Offers", url: "/offers" },
          { menuName: "Add Offers", url: "/addoffers" },
        ],
      },
      {
        // 5 => Settings
        icon: "ri-settings-line",
        menuName: "Settings",
        url: "#",
        submenu: [
          { menuName: "Admin setting", url: "/adminsetting" },
          { menuName: "Profile setting", url: "/admin-profile-settings" },
        ],
      },
    ];
  } else if (user.role === "employee") {
    return [
      {
        // 0 => Dashboard
        icon: "ri-home-line",
        menuName: "Dashboard",
        url: "/employee-dashboard",
        submenu: [],
      },
      {
        // 1 => Product
        icon: "ri-store-3-line",
        menuName: "Inventory Management",
        url: "#",
        submenu: [
          { menuName: "Vendor & Product", url: "/vendor/1" },
          { menuName: "List of product", url: "/listofproducts" },
          { menuName: "Add product", url: "/adminproductsaddorupdate" },
          { menuName: "Add stock", url: "/stockaddorupdate/" },
          { menuName: "Add Vendor", url: "/vendoraddorupdate/" },
          { menuName: "Vendor Applications", url: "/vendor-applications" }, // moved here
          { menuName: "Category & SubCategory", url: "/product-category-add" },
        ],
      },
      {
        // 3 => Drivers
        icon: "ri-user-3-line",
        menuName: "Drivers management",
        url: "/vendor/3",
        submenu: [
          { menuName: "Driver", url: "/driver" },
          { menuName: "Add driver", url: "/driveraddorupdate" },
        ],
      },
      {
        // 4 => Customer
        icon: "ri-user-3-line",
        menuName: "Customer Management",
        url: "/customer",
        submenu: [
          { menuName: "Customer", url: "/customer" },
          { menuName: "Contact Messages", url: "/ContactMessages" },
        ],
      },
      {
        // 5 => Order & delivery
        icon: "fas fa-truck",
        menuName: "Order & delivery",
        url: "/vendor/4",
        submenu: [
          { menuName: "Orders", url: "/order" },
          { menuName: "Assign Order", url: "/assign-order" },
          { menuName: "Driver Assignments", url: "/driver-assignments" },
          { menuName: "Review", url: "/review" },
          { menuName: "ReAssignDrivers", url: "/ReAssignDrivers" }
          // { menuName: "Delivery", url: "/delivery" },
        ],
      },
      {
        // 6 => Accounts
        icon: "fas fa-landmark",
        menuName: "Accounts",
        url: "#",
        submenu: [
          // { menuName: "Collection Cash", url: "/collectioncash" },
          { menuName: "Driver Deposit Cash", url: "/driverdepositcash" },
          { menuName: "Vendor Deposit Cash", url: "/vendordepositcash" },
           { menuName: "Driver Commission", url: "/admin/driver-commission" },
        ],
      },
      {
        // 7 => Offer Management
        icon: "fas fa-tags",
        menuName: "Offres management",
        url: "#",
        submenu: [
          { menuName: "Offres", url: "/offers" },
          { menuName: "Add Offres", url: "/addoffers" },
        ],
      },
      {
        // 8 => Settings
        icon: "ri-settings-line",
        menuName: "Settings",
        url: "#",
        submenu: [
          { menuName: "Profile setting", url: "/employee-profile-settings" },
        ],
      },
    ];
  } else if (user.role === "vendor") {
    return [
      {
        // 0 => Dashboard
        icon: "ri-home-line",
        menuName: "Dashboard",
        url: "/vendor-dashboard",
        submenu: [],
      },
      {
        // 1 => Product
        icon: "ri-store-3-line",
        menuName: "Inventory Management",
        url: "#",
        submenu: [
          { menuName: "Product", url: "/product" },
          { menuName: "Add stock", url: "/stockaddorupdate/" },
        ],
      },
      {
        // 2 => Order & delivery
        icon: "fas fa-truck",
        menuName: "Order & delivery",
        url: "/vendor/4",
        submenu: [
          { menuName: "Orders", url: "/orders" },
          { menuName: "Review", url: "/VendorReview" },
          // { menuName: "Delivery", url: "/delivery" },
        ],
      },
      {
        // 3 => Accounts
        icon: "fas fa-landmark",
        menuName: "Accounts",
        url: "#",
        submenu: [
          { menuName: "Vendor Deposit Cash", url: "/vendordepositcash" },
        ],
      },
      {
        // 4 => Settings
        icon: "ri-settings-line",
        menuName: "Settings",
        url: "#",
        submenu: [
          { menuName: "Profile setting", url: "/vendor-profile-settings" },
        ],
      },
    ];
  }

  return [];
};
export default useMenus;
